import { render, staticRenderFns } from "./SectionMain.vue?vue&type=template&id=7551d5ed&scoped=true"
import script from "./SectionMain.vue?vue&type=script&lang=ts"
export * from "./SectionMain.vue?vue&type=script&lang=ts"
import style0 from "./SectionMain.vue?vue&type=style&index=0&id=7551d5ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551d5ed",
  null
  
)

export default component.exports